import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import Introduction from "./sections/Introduction";
import AcademicTutoringCoreService from "./sections/AcademicTutoringCoreService";
import AcademicCoachingConfidenceFocusPerformance from "./sections/AcademicCoachingConfidenceFocusPerformance";
import OnlineCoursesAndDigitalLearningComingSoon from "./sections/OnlineCoursesAndDigitalLearningComingSoon";
import HowOurServicesWorkTogether from "./sections/HowOurServicesWorkTogether";
import NextSteps from "./sections/NextSteps";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <Introduction />
      <AcademicTutoringCoreService />
      <AcademicCoachingConfidenceFocusPerformance />
      <OnlineCoursesAndDigitalLearningComingSoon />
      <HowOurServicesWorkTogether />
      <NextSteps />
      <Footer />
    </div>;
}